import { render, staticRenderFns } from "./ChickensMain.vue?vue&type=template&id=45337e20&scoped=true"
import script from "./ChickensMain.vue?vue&type=script&lang=js"
export * from "./ChickensMain.vue?vue&type=script&lang=js"
import style0 from "./ChickensMain.vue?vue&type=style&index=0&id=45337e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45337e20",
  null
  
)

export default component.exports